import React, { createContext, useState } from 'react';

export const TimeIntervalContext = createContext();


const TimeContext = ({ children }) => {
    const [timeState,setTimeState]=useState("1m")
    console.log("this is timestate" + timeState);
    
    const changeTimeState =(timeData)=>{
        setTimeState(timeData)
    }
    return (
        <>
            <TimeIntervalContext.Provider value={{timeState,changeTimeState}}>
                {children}
            </TimeIntervalContext.Provider>
        </>
    )
}

export default TimeContext
